import { render, staticRenderFns } from "./rev_sp.vue?vue&type=template&id=882ae952"
import script from "./rev_sp.vue?vue&type=script&lang=js"
export * from "./rev_sp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports